<template>
  <span>
    <i :class="eventList[event].icon"></i> {{ eventList[event].description }}
  </span>
</template>

<script>

  import CertService from "@/services/cert-service"

  export default {

    data() {
      return {
        eventList: CertService.EVENTS,
      }
    },

    props: ["event"], 

  }
</script>